<script>
import { layoutComputed } from "@/state/helpers";
import Vertical from "./vertical";
import Horizontal from "./horizontal";

export default {
  components: {
    Vertical,
    Horizontal,
  },
  data() {
    return {
      displayUI: true,
    };
  },
  computed: {
    ...layoutComputed,
  },
  mounted() {
    if (window.screen.width > 767) {
      this.displayUI = true;
    }
  },
  methods: {},
};
</script>

<template>
  <div v-if="displayUI">
    <vertical v-if="layoutType === 'vertical'" :layout="layoutType">
      <slot />
    </vertical>

    <Horizontal v-if="layoutType === 'horizontal'" :layout="layoutType">
      <slot />
    </Horizontal>
  </div>
  <div
    class="row text-center"
    style="
      height: 100vh;
      display: flex;
      justify-content: center;
      align-items: center;
    "
    v-else
  >
    <div class="col-xs-8">
      <img
        src="@/assets/images/users/avatar-1.jpg"
        alt
        class="avatar-lg rounded-circle img-thumbnail"
      />
      <div class="mt-3">
        <h4>Diese Webseite ist nicht für mobile Endgeräte verfügbar</h4>
      </div>
    </div>
  </div>
</template>
